export const subAccounts = {
  title: 'Sub-Accounts',
  subtitle: 'Manage team members and reseller customers',
  navTitle: 'Sub-Accounts',
  invite: 'Invite',
  mySubAccounts: 'My Sub-Accounts',
  myParents: 'My Parent Accounts',
  filterAll: 'All',
  search: 'Search...',
  loading: 'Loading sub-accounts...',
  empty: 'No Sub-Accounts',
  emptyChildren: 'You have no sub-accounts yet. Invite team members or reseller customers.',
  emptyParents: 'You are not assigned to any parent account.',
  billingShared: 'Shared Billing',
  billingIndependent: 'Independent Billing',
  inviteExpires: 'Valid until {date}',
  types: {
    team: 'Team',
    reseller: 'Reseller'
  },
  switchedNotice: 'You manage sub-accounts in your own account. Return to it to see them.',
  status: {
    active: 'Active',
    pending: 'Pending',
    deactivated: 'Deactivated',
    expired: 'Expired',
    revoked: 'Revoked',
    awaitingAcceptance: 'Awaiting confirmation'
  },
  roles: {
    viewer: 'Viewer',
    editor: 'Editor',
    manager: 'Manager'
  },
  roleDescriptions: {
    viewer: 'Reads domains, mail and hosting without changing anything. Passwords, SFTP access and the kubeconfig stay hidden.',
    editor: 'Reads and changes domains, mail and hosting, including passwords, SFTP access and the kubeconfig. Cannot delete anything.',
    manager: 'Everything an editor can do, plus deleting, servers included. Billing, payments and account settings stay with the owner.'
  },
  actions: {
    resend: 'Resend invitation',
    edit: 'Edit',
    revoke: 'Revoke invitation',
    deactivate: 'Deactivate',
    reactivate: 'Reactivate',
    delete: 'Remove'
  },
  removeModal: {
    revokeTitle: 'Revoke invitation?',
    revokeMessage: 'The invitation to {account} stops working.',
    deleteTitle: 'Remove link?',
    deleteMessage: 'The link with {account} is removed for good. A new one needs a new invitation.'
  },
  parentActions: {
    reacceptNote: 'Your reseller asks to restore access. Accept it with the link in the invitation email.',
    leave: 'Leave link',
    leaveTitle: 'Leave this link?',
    leaveMessage: {
      team: 'You lose access to the account of {account}. {account} is told.',
      reseller: 'You will no longer be a customer of {account}. {account} is told.'
    },
    billingTitle: 'Change the billing mode?',
    billingMessage: {
      shared: 'The reseller can then order in your name, use and manage the payment methods in your account and see your invoices. Invoices still go to you.',
      independent: 'You then pay for the services in your account yourself, and the reseller can no longer order or pay for anything for you.'
    },
    billingTo: {
      shared: 'Switch to shared billing',
      independent: 'Switch to independent billing'
    }
  },
  inviteSlider: {
    title: 'Invite Sub-Account',
    subtitle: 'Invite a team member or reseller customer',
    email: 'Email Address',
    emailPlaceholder: "email{'@'}example.com",
    type: 'Relationship Type',
    billingMode: 'Billing Mode',
    teamRole: 'Team Role',
    label: 'Label',
    labelPlaceholder: 'e.g. Dev Team, Agency XY...',
    resellerUnavailable: 'Reseller customers are not enabled for your account. Contact support to enable them.',
    send: 'Send Invitation'
  },
  editSlider: {
    title: 'Edit Sub-Account',
    type: 'Type',
    status: 'Status',
    billingMode: 'Billing Mode',
    teamRole: 'Team Role',
    label: 'Label',
    billingRelaxHint: {
      reseller: 'Only the customer can switch back to shared billing.',
      team: 'Only support can switch back to shared billing.'
    }
  },
  deactivateModal: {
    title: 'Deactivate Sub-Account?',
    message: 'Are you sure you want to deactivate the relationship with {account}?',
    warning: 'The sub-account will lose access to your resources.',
    confirm: 'Deactivate',
    reason: 'Reason'
  },
  contextBanner: {
    actingTeam: 'You are working as a team member in the account {account}, limited to your team role.',
    actingReseller: 'You are working as a reseller in the account {account}.',
    returnBtn: 'Return to your account',
    returnFailed: 'Could not return'
  },
  inviteAccept: {
    title: 'Accept Invitation',
    subtitle: '{name} has invited you as a sub-account',
    from: 'From',
    type: 'Type',
    billing: 'Billing',
    accept: 'Accept Invitation',
    decline: 'Decline',
    loading: 'Loading invitation...',
    errorTitle: 'Error',
    invalidToken: 'This invitation is invalid or has expired.',
    loadError: 'Could not load the invitation.',
    acceptError: 'Could not accept the invitation.',
    successTitle: 'Invitation Accepted',
    successMessage: 'You are now linked as a sub-account.',
    goHome: 'Go Home',
    goDashboard: 'Go to Dashboard',
    for: 'For',
    expires: 'Valid until',
    billingSharedNote: 'With shared billing, the reseller can order in your name, use and manage the payment methods in your account and see your invoices. Invoices go to you.',
    billingIndependentNote: 'With independent billing, you pay for the services in your account yourself. The reseller cannot order or pay for anything for you.',
    loginPrompt: 'Log in with the invited account to accept the invitation.',
    loginToAccept: 'Log in to accept',
    register: 'No account yet? Register',
    otherAccount: 'This invitation is for {email}. Log in with that account to accept or decline it.',
    loginRequired: 'Your session has expired. Please log in again.',
    unknown: 'This invitation does not exist, or no longer does. It may have been withdrawn or declined.',
    used: 'This invitation has already been used.',
    expired: 'This invitation has expired. Ask the person who invited you for a new one.',
    deactivated: 'The sender has deactivated this invitation.',
    inviterLimit: 'The inviting account has no room left for you. Ask the person who invited you to sort it out.',
    resellerParentExists: 'Your account already belongs to another reseller. Leave that link first if you want to switch.',
    declinedTitle: 'Invitation declined',
    declinedMessage: 'The invitation is declined, and the person who invited you is told.'
  },
  resources: {
    tab: 'Resources',
    title: 'Sub-Account Resources',
    subtitle: 'Overview of all domains and mail accounts of your sub-accounts',
    loading: 'Loading resources...',
    empty: 'No Resources',
    emptyMessage: 'Your sub-accounts don\'t have any domains or mail accounts yet.',
    domains: 'Domains',
    mailAccounts: 'Mail Accounts',
    domainStatus: {
      active: 'Active',
      pending_delete: 'Cancelled',
      deleted: 'Deleted',
      suspended: 'Suspended',
      trade_out: 'Transfer',
      transfer_pending: 'Transfer pending',
      external: 'External'
    },
    activeUntil: 'Active until',
    switchTo: 'Manage',
    totalDomains: 'Total domains',
    totalMail: 'Total mail accounts'
  },
  errors: {
    labelTooLong: 'The label is too long. Shorten it; accented characters count double.',
    switch_target_forbidden: 'You cannot switch to this account.',
    invite_resend_cooldown: 'This invitation was sent only a moment ago. You can resend it in a few minutes.',
    conflicting_relationship: 'These accounts already have a different link.',
    parent_not_reseller: 'This account may not have reseller customers.',
    action_blocked_during_impersonation: 'This is not possible during an impersonation.',
    rateLimited: 'Too many changes in a short time. Please try again later.',
    generic: 'That did not work. Please try again.',
    account_not_found: 'This account does not exist.',
    relationship_not_found: 'This link no longer exists. Reload the page.',
    invalid_token: 'This invitation does not exist.',
    self_relationship: 'You cannot invite yourself.',
    team_role_required: 'A team member needs a team role.',
    invalid_team_grant: 'One of the permissions is not available to team members.',
    already_linked: 'You are already linked with this account, or an invitation is already open.',
    relationship_inactive:
      'There is a deactivated link with this account. Reactivate or remove it in the list.',
    max_team_members_reached: 'You have reached your team member limit.',
    max_sub_customers_reached:
      'You have reached your reseller customer limit. Contact support if you need more.',
    reseller_parent_exists: 'This account is already a customer of another reseller.',
    circular_relationship: 'This account is already linked with you the other way round.',
    invite_not_pending: 'This invitation is no longer open.',
    relationship_not_active: 'This link is not active.',
    relationship_already_active: 'This link is already active.',
    relationship_never_accepted: 'This link was never accepted and cannot be reactivated. Invite the person again.',
    invite_expired: 'This invitation has expired.',
    invite_email_mismatch: 'The invitation was sent to a different email address.',
    invalid_relationship: 'You are not allowed to change this link.',
    billing_mode_change_forbidden:
      'You are not allowed to make this billing mode change. Only the customer can switch back to shared billing.',
    email_not_verified: 'Confirm your email address first, then you can do this.',
    team_invite_from_staff: 'Staff accounts cannot invite team members.'
  },
  contextErrors: {
    login_mailbox_protected: "This address is an account's login address. Its mail cannot be changed while you work in another account.",
    login_domain_protected:
      "This domain carries an account's login address. Changes that decide where its mail is delivered, such as to MX records, nameservers or DynDNS for the mail server, cannot be made while you work in another account. That way nobody can route this address's mail, password resets included, to another server. The owner can make them in their own account.",
    team_context_forbidden: 'Only the account owner can do this. It is not available to team members.',
    acting_context_forbidden: 'This only works in your own account. Return to your account first.',
    independent_billing_forbidden:
      'This customer is billed independently and manages payments, orders and contracts themselves.'
  },
  notifications: {
    reactivationPending: 'Confirmation Requested',
    reactivationPendingMessage: 'The customer gets an invitation and has to confirm the link again.',
    left: 'Link Left',
    leftMessage: 'You are no longer linked with this account.',
    billingChanged: 'Billing Mode Changed',
    billingChangedMessage: 'The new billing mode applies from now on.',
    inviteResent: 'Invitation Resent',
    inviteResentMessage: 'The invitation is valid for another 7 days.',
    reactivated: 'Reactivated',
    reactivatedMessage: 'The sub-account relationship is active again.',
    removed: 'Removed',
    removedMessage: 'The sub-account relationship has been removed.',
    inviteRevoked: 'Invitation Revoked',
    inviteRevokedMessage: 'The invitation no longer works.',
    inviteSent: 'Invitation Sent',
    inviteSentMessage: 'The invitation has been sent successfully.',
    updated: 'Updated',
    updatedMessage: 'The sub-account relationship has been updated.',
    deactivated: 'Deactivated',
    deactivatedMessage: 'The sub-account relationship has been deactivated.'
  }
} as const
